import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { toast } from 'react-toastify';
import { formatToUSD, rootUrl, sumArray } from '../../helpers';
import { useAuth } from '../../context/auth-context';
import { FiList } from 'react-icons/fi';
import { FaList } from 'react-icons/fa';

const ViewPurchaseOrderAndPaymentVoucher = () => {
  const [purchaseOrders, setPurchaseOrders] = useState([]);
  const [paymentVouchers, setPaymentVouchers] = useState([]);
  const [recs, setRecs] = useState([]);
  const [poVisible, setPoVisible] = useState(false);
  const [pvVisible, setPvVisible] = useState({});

  const auth = useAuth();

  const fetchOrdersAndVouchers = async () => {
    try {
      const response = await axios.get(rootUrl(`/get-in-transit/${auth.user.id}`));
      setRecs([...new Set(response.data.data.map((res) => res.reciept))]);
      setPurchaseOrders(response.data.data);
      setPaymentVouchers(response.data.data);
    } catch (error) {
      console.error('Error fetching PO and PV data', error);
      toast.error('Failed to fetch Purchase Orders and Payment Vouchers');
    }
  };

  useEffect(() => {
    fetchOrdersAndVouchers();
  }, []);

  const togglePvVisibility = (reciept) => {
    setPvVisible((prev) => ({ ...prev, [reciept]: !prev[reciept] }));
  };

  return (
    <div className="container mx-auto p-4 shadow-lg rounded-lg">
        <div>
        <h2 className="text-xl font-bold flex items-center"> <FaList/> My Transactions</h2>
        </div>
        <hr className='my-3' />

      {/* Purchase Orders Section */}
      <div className="mb-6">
        <div
          className="cursor-pointer bg-gray-200 p-3 rounded-lg mb-2"
          onClick={() => setPoVisible(!poVisible)}
        >
          <h3 className="text-xl font-semibold">Purchase Orders</h3>
        </div>
        {poVisible && (
          purchaseOrders.length === 0 ? (
            <div>No Purchase Orders available</div>
          ) : (
            purchaseOrders.map((po, index) => (
              <div key={po.id} className="border rounded-lg m-3 p-4">
                <div className="font-bold text-lg text-center">
                  <div className="flex justify-center">
                    <img src="/logo1.png" className="w-24" alt="Logo" />
                  </div>
                  <span>Ministry of Mines and Development</span>
                  <br />
                  <span>Purchase Order</span>
                </div>

                <div>Date: {po.date.substring(0, 10)}</div>
                <div>Seller: {po.name}</div>
                <div>Order #: {po.reciept}</div>

                <table className="min-w-full table-auto border-collapse border border-gray-200">
                  <thead>
                    <tr className="bg-gray-100">
                      <th className="px-4 py-2 text-left">Sno</th>
                      <th className="px-4 py-2 text-left">Description</th>
                      <th className="px-4 py-2 text-left">Weight(grams)</th>
                      <th className="px-4 py-2 text-left">Unit Price</th>
                      <th className="px-4 py-2 text-left">Total Amount ($)</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td className="px-4 py-2">{++index}</td>
                      <td className="px-4 py-2">Gold ({po.type})</td>
                      <td className="px-4 py-2">$84</td>
                      <td className="px-4 py-2">{po.weight}</td>
                      <td className="px-4 py-2">{formatToUSD(parseFloat(po.weight) * 84)}</td>
                    </tr>
                    <tr className="font-bold">
                      <td className="px-4 py-2" colSpan={3}>Total</td>
                      <td className="px-4 py-2">{po.weight}</td>
                      <td className="px-4 py-2">{formatToUSD(parseFloat(po.weight) * 84)}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            ))
          )
        )}
      </div>

      {/* Payment Vouchers Section */}
      <div>
        <h3 className="text-xl font-semibold mb-3">Payment Vouchers</h3>
        {recs.map((reciept) => (
          <div key={reciept} className="mb-4">
            <div
              className="cursor-pointer bg-gray-200 p-3 rounded-lg"
              onClick={() => togglePvVisibility(reciept)}
            >
              <span>Voucher #: {reciept}</span>
            </div>
            {pvVisible[reciept] && (
              <div className="border rounded-lg m-3 p-4">
                <div className="font-bold text-lg text-center">
                  <div className="flex justify-center">
                    <img src="/logo1.png" className="w-24" alt="Logo" />
                  </div>
                  <span>Ministry of Mines and Development</span>
                  <br />
                  <span>Payment Voucher</span>
                </div>

                <div>
                  Date: {paymentVouchers.filter((a) => a.reciept === reciept)[0].date.substring(0, 10)}
                </div>
                <div>
                  Seller: {paymentVouchers.filter((a) => a.reciept === reciept)[0].name}
                </div>

                <table className="min-w-full table-auto border-collapse border border-gray-200">
                  <thead>
                    <tr className="bg-gray-100">
                      <th className="px-4 py-2 text-left">Sno</th>
                      <th className="px-4 py-2 text-left">Description</th>
                      <th className="px-4 py-2 text-left">Weight(grams)</th>
                      <th className="px-4 py-2 text-left">Unit Price</th>
                      <th className="px-4 py-2 text-left">Total Amount ($)</th>
                    </tr>
                  </thead>
                  <tbody>
                    {paymentVouchers.filter((a) => a.reciept === reciept).map((pv, index) => (
                      <tr key={pv.id}>
                        <td className="px-4 py-2">{++index}</td>
                        <td className="px-4 py-2">Gold ({pv.type})</td>
                        <td className="px-4 py-2">$84</td>
                        <td className="px-4 py-2">{pv.weight}</td>
                        <td className="px-4 py-2">{formatToUSD(parseFloat(pv.weight) * 84)}</td>
                      </tr>
                    ))}

                    <tr className="font-bold">
                      <td className="px-4 py-2" colSpan={3}>Total</td>
                      <td className="px-4 py-2">
                        {sumArray(paymentVouchers.filter((a) => a.reciept === reciept).map((res) => parseFloat(res.weight)))}
                      </td>
                      <td className="px-4 py-2">
                        {formatToUSD(sumArray(paymentVouchers.filter((a) => a.reciept === reciept).map((res) => parseFloat(res.weight) * 84)))}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default ViewPurchaseOrderAndPaymentVoucher;
